import Link from "next/link";
import { Col, Row } from "reactstrap";
import { IoIosArrowBack } from "react-icons/io";

//local imports
import classes from "@/styles/contests/contests-main.module.css";
import { routes } from "@/utils/routes";
import { airmilesContest } from "@/utils/content";
import AirmilesContest from "./airmiles-contest";

export default function ContestsMain() {
  const content = airmilesContest.en;

  return (
    <div className={classes.container}>
      <div className="container my-5">
        <Row>
          <Col className={classes.col1} xs={12} lg={2}>
            <Link
              className="text-dark d-flex align-items-center border-bottom py-2"
              href={routes.contests}
            >
              <IoIosArrowBack size={20} />
              &nbsp;{content.contests}
            </Link>
            <Link
              className="text-dark border-bottom py-2"
              href={routes.airmilesGiveAway}
            >
              {content.airMiles}
            </Link>
          </Col>
          <Col xs={12} lg={10}>
            <AirmilesContest />
          </Col>
        </Row>
      </div>
    </div>
  );
}
